import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, Text } from '@zillow/constellation';
import { useMobileAppState } from '@zillow/shopper-platform-config';

import { createMicroFrontend } from '@zillow/frontier';
import { sendViewEvent } from '../../util/shopperAdUtil';
import MstHomeDetailsGoogleAds, { AD_TYPE } from './MstHomeDetailsGoogleAds';

function MstServicesAvailability({ targets, variant, className, versOn }) {
    const isMobileApp = useMobileAppState();
    const showTelecomAd = !isMobileApp && !!targets;

    if (showTelecomAd) {
        sendViewEvent();
        return (
            <Spacer data-testid="MstServicesAvailability" marginY="sm" className={className}>
                <Text fontType="h5" as="h5">
                    Services availability
                </Text>
                <Spacer marginTop="xs">
                    <MstHomeDetailsGoogleAds
                        targets={targets}
                        variant={variant}
                        versOn={versOn}
                        targetDiv="hdp_telco_slot_box_1"
                        adType={AD_TYPE.GENERIC_CENTER_AD}
                        eventName="TelecomAd"
                    />
                </Spacer>
            </Spacer>
        );
    }
    return null;
}

MstServicesAvailability.propTypes = {
    targets: PropTypes.object,
    variant: PropTypes.string,
    versOn: PropTypes.string,
    className: PropTypes.string,
};

const MstServicesAvailabilityMicroFrontend = createMicroFrontend({
    Component: MstServicesAvailability,
    onMicroFrontendLoad() {
        console.log('success load');
    },
    onMicroFrontendLoadError() {
        console.error('error loading');
    },
    fetchData: async () => {},
    getGraphQLFragments: () => {},
});

export default MstServicesAvailabilityMicroFrontend;
